/*jshint ignore:start*/

(function()
{
	function DanceOff()
	{
		this.View_constructor();

		this.allowTimers = false;
		this.playTimer = 0;
		this.idleTimer = 0;
		this.characterIsDancing = false;
		this.analyticsDanceButtonPresses = 0;
		this.analyticsSfxButtonPresses = 0;

		this.danceModeMC = new cm.Assets.lib.MainAnimsLib.mc_danceMode_container();
		this.danceModeMC.set({x: -512, y: -350, framerate: 30, scaleX: 1.05, scaleY: 1.05});

		this.danceBG = new cjs.Bitmap(cm.Assets.lib.DanceoffBG);
		this.danceModeMC.bgContainer.addChild(this.danceBG);

		this.dancingCharacter = new cm.Assets.lib.MainAnimsLib['mc_' + cm.app.game.currentCharacterName + '_dances']();
		this.dancingCharacter.set({framerate: 30});

		var head;
		var regex = /(dance_\w+)/g;
		var key;
		this.lipsyncContainers = {};

		var instance = this.dancingCharacter.idle;
		var i = 0;

		this.lipsyncContainers.dance_idle = instance.getBodypartInstances('mc_'+ cm.app.game.currentCharacterName + '_container_head')[0].lipsyncMouthContainer;

		while (instance) 
		{
			head = instance.getBodypartInstances('mc_'+ cm.app.game.currentCharacterName + '_container_head')[0];
			key = regex.exec(instance.className)[1];
			regex.lastIndex = 0;
			this.lipsyncContainers[key] = head.lipsyncMouthContainer;
			instance.set({framerate: 30});
			instance.changeSnapToPixel(false);
			this.setDancingCharacterCostume(instance);
			instance = this.dancingCharacter['dance' + (++i)];
		}

		this.danceModeMC.characterDanceContainer.addChild(this.dancingCharacter);

		this.menuBtn = new cm.Assets.lib.MainAnimsLib.btn_menu();
		this.menuBtn.set({x: -cm.app.display.width/2, y: -cm.app.display.height/2, mouseChildren: false});
		this.menuBtn.stop();

		this.danceModeMC.danceView = this;

		this.addChild(
			this.danceModeMC,
			this.menuBtn
		);

		this.danceModeMC.stop();

		this.danceModeMC.btn_changeOutfit.mouseChildren = false;
		this.danceModeMC.btn_menu_round.mouseChildren = false;
		this.danceModeMC.btn_changeOutfit.mode = 'single';
		this.danceModeMC.btn_menu_round.mode = 'single';

		var _this = this;
		this.danceModeMC.forceButtonsToProperCharacter = function() 
		{
			_this.danceModeMC.btn_dance_1.btn.set({mode: 'independent', autoReset: false}).gotoAndStop(cm.game.currentCharacterName);
			_this.danceModeMC.btn_dance_2.btn.set({mode: 'independent', autoReset: false}).gotoAndStop(cm.game.currentCharacterName);
			_this.danceModeMC.btn_dance_3.btn.set({mode: 'independent', autoReset: false}).gotoAndStop(cm.game.currentCharacterName);
			_this.danceModeMC.btn_dance_4.btn.set({mode: 'independent', autoReset: false}).gotoAndStop(cm.game.currentCharacterName);
			_this.danceModeMC.btn_dance_5.btn.set({mode: 'independent', autoReset: false}).gotoAndStop(cm.game.currentCharacterName);
			_this.danceModeMC.btn_dance_6.btn.set({mode: 'independent', autoReset: false}).gotoAndStop(cm.game.currentCharacterName);

		};

		this.danceModeMC.freezeButtons = function() 
		{
			_this.danceModeMC.btn_dance_1.set({mouseChildren: false, mode: 'single', name: 'Left_Top'});
			_this.danceModeMC.btn_dance_2.set({mouseChildren: false, mode: 'single', name: 'Left_Middle'});
			_this.danceModeMC.btn_dance_3.set({mouseChildren: false, mode: 'single', name: 'Left_Bottom'});
			_this.danceModeMC.btn_dance_4.set({mouseChildren: false, mode: 'single', name: 'Right_Top'});
			_this.danceModeMC.btn_dance_5.set({mouseChildren: false, mode: 'single', name: 'Right_Middle'});
			_this.danceModeMC.btn_dance_6.set({mouseChildren: false, mode: 'single', name: 'Right_Bottom'});


			_this.danceModeMC.btn_changeOutfit.stop();
			_this.danceModeMC.btn_menu_round.stop();
			_this.danceModeMC.btn_dance_1.stop();
			_this.danceModeMC.btn_dance_2.stop();
			_this.danceModeMC.btn_dance_3.stop();
			_this.danceModeMC.btn_dance_4.stop();
			_this.danceModeMC.btn_dance_5.stop();
			_this.danceModeMC.btn_dance_6.stop();
		};


		var annoying = this.danceModeMC.fxContainer.fx_btns_container;
		annoying.btn_fx_disco.set({mouseChildren: false, mode: 'single', name: 'Middle'});
		annoying.btn_fx_disco.stop();
		annoying.btn_fx_feather.set({mouseChildren: false, mode: 'single', name: 'Right'});
		annoying.btn_fx_feather.stop();
		annoying.btn_fx_sparkle.set({mouseChildren: false, mode: 'single', name: 'Left'});
		annoying.btn_fx_sparkle.stop();

		this.effectsBtns = [
			annoying.btn_fx_sparkle,
			annoying.btn_fx_disco,
			annoying.btn_fx_feather
		];


		this.danceModeMC.effect_mc.mode = 'single';
		this.danceModeMC.effect_mc.gotoAndStop(0);
	}

	var p = createjs.extend(DanceOff, cm.View);

	p.start = function() 
	{
		this.danceModeMC.onAnimationEndCallback = function() {
			
			this.danceModeMC.btn_dance_1.mode = 'independent';
			this.danceModeMC.btn_dance_2.mode = 'independent';
			this.danceModeMC.btn_dance_3.mode = 'independent';
			this.danceModeMC.btn_dance_4.mode = 'independent';
			this.danceModeMC.btn_dance_5.mode = 'independent';
			this.danceModeMC.btn_dance_6.mode = 'independent';


			var annoying = this.danceModeMC.fxContainer.fx_btns_container;
			annoying.btn_fx_disco.set({mode: 'independent'});
			annoying.btn_fx_feather.set({mode: 'independent'});
			annoying.btn_fx_sparkle.set({mode: 'independent'});

			this.danceModeMC.effect_mc.mode = 'independent';

			this.playIntro();



		}.bind(this);


		this.musicLoop = cm.app.sound.play('DressUpMusic_07v2', {
			volume: 0, 
			loop: true
		});


		console.log(this.musicLoop);
		if (this.musicLoop)
		{
			// springroll.Sound fadeIn garbage not working consistently for 
			// some reason I don't have time to figure out, so this will be the fix for now.
			cjs.Tween.get(this.musicLoop)
				.to({volume: 0.3}, 500);
		}


		// if (this.musicLoop)
		// {
		// 	cm.app.sound.fadeIn(this.musicLoop, 500, 0.3, 0);
		// }

		cm.app.sound.play('curtainOpen');
		this.danceModeMC.gotoAndPlay('openCurtain');	
		this.dancingCharacter.stop();

		this.danceModeMC.btn_dance_1.btn.mode = 'single';
		this.danceModeMC.btn_dance_2.btn.mode = 'single';
		this.danceModeMC.btn_dance_3.btn.mode = 'single';
		this.danceModeMC.btn_dance_4.btn.mode = 'single';
		this.danceModeMC.btn_dance_5.btn.mode = 'single';
		this.danceModeMC.btn_dance_6.btn.mode = 'single';

		this.danceModeMC.btn_dance_1.btn.gotoAndStop(cm.app.game.currentCharacterName);
		this.danceModeMC.btn_dance_2.btn.gotoAndStop(cm.app.game.currentCharacterName);
		this.danceModeMC.btn_dance_3.btn.gotoAndStop(cm.app.game.currentCharacterName);
		this.danceModeMC.btn_dance_4.btn.gotoAndStop(cm.app.game.currentCharacterName);
		this.danceModeMC.btn_dance_5.btn.gotoAndStop(cm.app.game.currentCharacterName);
		this.danceModeMC.btn_dance_6.btn.gotoAndStop(cm.app.game.currentCharacterName);

	};

	p.endDancing = function() 
	{
		cm.analytics.endDancingRound('Dancing Complete', this.analyticsDanceButtonPresses, this.analyticsSfxButtonPresses);

		this.dancingEnded = true;

		this.allowTimers = false;
		this.danceModeMC.mouseEnabled = false;
		this.danceModeMC.btn_changeOutfit.mouseEnabled = false;
		this.danceModeMC.btn_menu_round.mouseEnabled = false;
		this.danceModeMC.onAnimationEndCallback = this.promptChangeOutfit.bind(this);
		this.danceModeMC.gotoAndPlay('closeCurtain');
	};

	p.promptChangeOutfit = function() 
	{
		this.danceModeMC.btn_changeOutfit.mode = 'independent';
		this.danceModeMC.btn_menu_round.mode = 'independent';
		this.lipsyncContainers.dance_idle.playLipsync(
			cm.app.game.currentCharacterName + '_dance_changeOutfit',
			this._promptChangeOutfit.bind(this)
		);
	};

	p._promptChangeOutfit = function() 
	{
		this.lipsyncContainers.dance_idle.playLipsync(
			cm.app.game.currentCharacterName + '_dance_pressThis',
			this.promptStartOver.bind(this)
		);

		this.danceModeMC.btn_changeOutfit.gotoAndStop('over');
		cjs.Tween.get(this.danceModeMC.btn_changeOutfit, {loop: true})
			.to({scaleX: 1.1, scaleY: 1.1}, 300, cjs.Ease.quadInOut)
			.to({scaleX: 1, scaleY: 1}, 300, cjs.Ease.quadInOut);

	};

	p.promptStartOver = function() 
	{
		this.danceModeMC.btn_changeOutfit.gotoAndStop('up');
		this.danceModeMC.mouseEnabled = true;
		cjs.Tween.get(this.danceModeMC.btn_changeOutfit, {override: true})
			.to({scaleX: 1, scaleY: 1}, 150, cjs.Ease.quadInOut);


		this.lipsyncContainers.dance_idle.playLipsync(
			cm.app.game.currentCharacterName + '_dance_startOver',
			this._promptStartOver.bind(this)
		);
	};

	p._promptStartOver = function()  
	{
		this.lipsyncContainers.dance_idle.playLipsync(
			cm.app.game.currentCharacterName + '_dance_pressThis',
			this._pulseStartOverBtn.bind(this)
		);

		this.danceModeMC.btn_menu_round.gotoAndStop('over');
		cjs.Tween.get(this.danceModeMC.btn_menu_round, {loop: true})
			.to({scaleX: 1.1, scaleY: 1.1}, 300, cjs.Ease.quadInOut)
			.to({scaleX: 1, scaleY: 1}, 300, cjs.Ease.quadInOut);
	};

	p._pulseStartOverBtn = function() 
	{
		this.danceModeMC.btn_menu_round.gotoAndStop('up');
		this.danceModeMC.mouseEnabled = true;
		this.danceModeMC.btn_changeOutfit.mouseEnabled = true;
		this.danceModeMC.btn_menu_round.mouseEnabled = true;
		cjs.Tween.get(this.danceModeMC.btn_menu_round, {override: true})
			.to({scaleX: 1, scaleY: 1}, 150, cjs.Ease.quadInOut);
	};

	p.destroy = function() 
	{
		this.View_destroy();
		if (this.musicLoop)
		{
			cjs.Tween.get(this.musicLoop)
				.to({volume: 0}, 500)
				.call(this.musicLoop.stop, null, this.musicLoop);
			// cm.app.sound.fadeOut(this.musicLoop);
		}
	};

	p.setActive = function(active) 
	{
		if (active === true) 
		{
			this.danceModeMC.on('click', this.handleInteraction, this);
			this.danceModeMC.on('mousedown', this.handleInteraction, this);
			this.danceModeMC.on('pressup', this.handleInteraction, this);
			this.menuBtn.on('click', this.handleInteraction, this);

			if (!cm.Device.mobile) 
			{
				this.menuBtn.on('mouseover', this.handleInteraction, this);
				this.menuBtn.on('mouseout', this.handleInteraction, this);
				this.danceModeMC.on('mouseover', this.handleInteraction, this);
				this.danceModeMC.on('mouseout', this.handleInteraction, this);
			}
		} 
		else 
		{
			this.danceModeMC.removeAllEventListeners();
			this.menuBtn.removeAllEventListeners();
			cjs.Tween.removeTweens(this.danceModeMC);
		}
	};

	p.playIntro = function() 
	{
		cm.app.voPlayer.play(
			cm.soundDictionary.getSoundID(cm.app.game.currentCharacterName + '_dance_danceIntro')
		);

		var wait = 0;
		var btn;

		for (var i = 0, l = this.effectsBtns.length; i < l; i++)
		{
			btn = this.effectsBtns[i];
			cjs.Tween.get(btn)
				.wait(500 + wait)
				.call(btn.gotoAndStop, ['over'], btn)
				.to({scaleX: 1.1, scaleY: 1.1}, 250, cjs.Ease.quadInOut)
				.wait(500)
				.to({scaleX: 1, scaleY: 1}, 250, cjs.Ease.quadInOut)
				.call(btn.gotoAndStop, ['up'], btn);

			wait += 100;
		}


		cjs.Tween.get(this.danceModeMC)
			.wait(500)
			.call(function() {
				cm.analytics.startRound('Dancing Play');
				this.allowTimers = true;
				this.danceModeMC.onAnimationEndCallback = this.setActive.bind(this, true);
				this.danceModeMC.gotoAndPlay('animate_buttons');
			}, null, this);
	};

	p.onQuitGame = function() 
	{
		if (this.dancingEnded)
		{
			cm.analytics.quitGame('Dancing Complete');
		} 
		else
		{
			cm.analytics.quitGame('Dancing Play');
		}
	};

	p.handleInteraction = function(e) 
	{
		var name;

		var dancingSounds = [
			[1, 2, 3],
			[1, 2, 3],
			[1, 2, 3, 4, 5],
			[1, 2],
			[1, 2],
			[1, 2]
		];



		if (e.target.className) 
		{
			name = e.target.className.split('_');
			switch(e.type) 
			{
				case 'click':
					if (e.target.className.indexOf('btn_') === 0) {

						this.idleTimer = 0;

						switch (name[1]) 
						{
							case 'dance':

								// eg: dance{number}_{random option}.. dance2_3, dance3_5;
								// Each dance button has a different number of sounds that are randomly chosen per dance.
								var danceNumber = dancingSounds[parseInt(name[2]) - 1].random();
								cm.app.sound.play('dance' + name[2] + '_' + danceNumber);

								this.analyticsDanceButtonPresses++;
								cm.analytics.event('ButtonSelectionDanceButton', e.target.name, null);

								if (Math.random() < 0.33)
								{
									var lipsync = cm.app.game.currentCharacterName + '_dance_dance' + Math.range(1, 6);
									this.lipsyncContainers['dance_'+name[2]].playLipsync(lipsync);
								}	

								this.characterIsDancing = true;

								this.dancingCharacter['dance'+name[2]].onAnimationEndCallback = this.onCharacterDanceEnd.bind(this);
								this.dancingCharacter.gotoAndStop('dance'+name[2]);
								break;
							case 'homebutton':
								this.danceModeMC.mouseEnabled = false;
								cm.analytics.event('ButtonSelectionDanceComplete', 'Home', null);
								cm.app.game.backToCharacterSelect();
								break;
							case 'menu':
								this.danceModeMC.mouseEnabled = false;
								cm.analytics.menuButtonPressed('Dancing Play');
								cm.app.game.backToCharacterSelect();
								break;
							case 'changeOutfit':
								this.danceModeMC.mouseEnabled = false;
								cm.analytics.event('ButtonSelectionDanceComplete', 'Dance Again', null);
								cm.app.game.backToCostumeSnapshotSelect();
								break;
							case 'fx':
								this.analyticsSfxButtonPresses++;
								cm.analytics.event('ButtonSelectionFXButton', e.target.name, null);
								cm.app.sound.play('click4', {volume: 0.6});
								this.danceModeMC.effect_mc.gotoAndStop(name[2] + 'FX');
								break;
							default:
								break;
						}
					}

					break;
				case 'mouseover':
					switch (name[1]) 
					{
						case 'homebutton':
							cm.app.sound.play('ro5', {volume: 0.6});
							break;
						case 'menu':
							cm.app.sound.play('charsel_btn_rollover', {volume: 0.6});
							break;
						case 'changeOutfit':
							cm.app.sound.play('ro5', {volume: 0.6});
							break;
						case 'dance':
						case 'fx':
							cm.app.sound.play('ro4', {volume: 0.6});
							break;
						default:
							break;
					}

					cm.app.game.hoverCursor();
					
					if (e.target.className.indexOf('btn_') === 0) {
						e.target.gotoAndStop('over');
					}	
					break;
				case 'mouseout':
					if (e.target.className.indexOf('btn_') === 0) {
						e.target.gotoAndStop('up');
					}	

					cm.app.game.unhoverCursor();
					break;
				case 'mousedown':
					e.target.gotoAndStop('down');
					break;
				case 'pressup':
					e.target.gotoAndStop('up');
					break;
				default:
					break;
			}
		}

	};

	p.onUserReEngage = function() 
	{
		if (!this.dancingEnded)
		{
			cm.analytics.userReengage('Dancing Play');
		}
	};

	p.onCharacterDanceEnd = function() 
	{
		this.characterIsDancing = false;
	};

	p.update = function(deltaT)
	{
		this.menuBtn.set({x: -cm.app.display.width/2, y: -cm.app.display.height/2});

		if (this.allowTimers) 
		{
			this.playTimer += deltaT;

			if (this.characterIsDancing === false && this.playTimer > cm.app.config.main_config.danceTime * 1000)
			{
				this.playTimer = 0;
				this.endDancing();
			}

			this.idleTimer += deltaT;

			if (this.idleTimer > 20000)
			{
				this.idleTimer = 0;
				cm.analytics.timeoutFired('Dancing Play');

				if (!this.dancingEnded)
				{
					var alias = cm.soundDictionary.getSoundID(cm.app.game.currentCharacterName + '_dance_danceIdle' + Math.range(1, 3));
					cm.app.voPlayer.play(alias);
				}
				else 
				{	

				}

			}

		} 
	};

	p.setDancingCharacterCostume = function(characterMovieClip) 
	{
		var charName = cm.app.game.currentCharacterName;
		var part;
		var partClass;
		var costume = cm.app.game.selectedCostumes[cm.app.game.chosenDanceCostume];
		var costumeName;
		var costumeLibName;

		costumeName = costume.top;
		costumeLibName = costumeName.replace(/Color|Pattern/g, '') + cm.app.game.costumePartsLibIDSlug;

		cm.app.game.addCostumeParts({
			costumeLib: cm.Assets.lib[costumeLibName],
			characterMovieClip: characterMovieClip,
			charName: charName,
			partName: 'head',
			costumeName: costumeName
		});

		costumeName = costume.middle;
		costumeLibName = costumeName.replace(/Color|Pattern/g, '') + cm.app.game.costumePartsLibIDSlug;

		var partNames = [
			'torso',
			'cape',
			'upperarm',
			'lowerarm',
			'hand',
			'upperleg'
		];

		for (var i = 0, l = partNames.length; i < l; i++) 
		{
			cm.app.game.addCostumeParts({
				costumeLib: cm.Assets.lib[costumeLibName],
				characterMovieClip: characterMovieClip,
				charName: charName,
				partName: partNames[i],
				costumeName: costumeName
			});
		}

		cm.app.game.addCostumeParts({
			costumeLib: cm.Assets.lib[costumeLibName],
			characterMovieClip: characterMovieClip,
			charName: charName,
			partName: 'lowerleg',
			lowerLegSegment: 'M',
			costumeName: costumeName
		});


		costumeName = costume.bottom;
		costumeLibName = costumeName.replace(/Color|Pattern/g, '') + cm.app.game.costumePartsLibIDSlug;

		// Feet
		cm.app.game.addCostumeParts({
			costumeLib: cm.Assets.lib[costumeLibName],
			characterMovieClip: characterMovieClip,
			charName: charName,
			partName: 'foot',
			costumeName: costumeName
		});

		// lower legs (ugh... handling an exceptional case for the pirate boots >:| )
		cm.app.game.addCostumeParts({
			costumeLib: cm.Assets.lib[costumeLibName],
			characterMovieClip: characterMovieClip,
			charName: charName,
			partName: 'lowerleg',
			lowerLegSegment: 'B',
			costumeName: costumeName
		});
	};


	cm.View.DanceOff = cjs.promote(DanceOff, "View");

})();

/*jshint ignore:end*/